import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'antd/lib/button';
import Input from 'antd/lib/input';
import { translate } from 'react-i18next';

@translate()
export default class Search extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    value: PropTypes.string,
    onSearch: PropTypes.func.isRequired,
  };  

  static defaultProps = {
    value: '',
  };

  state = {
    searchValue: '',
  };

  componentDidMount() {
    this.setState({ searchValue: this.props.value });
  }

  onChange = e => {
    this.setState({ searchValue: e.target.value });
  };

  handleSubmit = () => {
    this.props.onSearch(this.state.searchValue);
};

  handleReset = () => {
    this.setState({ searchValue: '' }, () => this.handleSubmit());
  };

  render() {
    const { t } = this.props;

    return (
      <div className="filter-search">
        <Input
          placeholder={t('Hľadať')}
          value={this.state.searchValue}
          onChange={this.onChange}
          onPressEnter={this.handleSubmit}
        />
        <Button size="small" onClick={this.handleSubmit} type="primary" icon="search" />
        <Button size="small" onClick={this.handleReset} icon="close" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/account-management/components/filters/Search.js